import { render, staticRenderFns } from "./UploadBtn.vue?vue&type=template&id=1302e264"
import script from "./UploadBtn.vue?vue&type=script&lang=ts"
export * from "./UploadBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports